import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0" aria-hidden="true">
        404
      </div>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Esta página no existe</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Volvamos al sitio principal</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line" />
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
